<template>
  <div class="container pathways__subcomponent">
    <div class="columns is-centered">
      <div class="column is-10-tablet is-8-desktop">
        <p class="title is-3 pathways-question__indicator">Question 9</p>
        <h2 class="title is-1">
          Has the person expressed the desire to cut down or stop using alcohol and/or other drugs?
        </h2>
        <div class="columns">
          <div class="column is-half-tablet">
            <PathwaysOption label-text="Yes">
              <input
                type="radio"
                name="yes"
                value="yes"
                v-model="lowerUsage"
                @change="setNextDisabled(false)"
              />
            </PathwaysOption>
          </div>
          <div class="column is-half-tablet">
            <PathwaysOption label-text="No">
              <input
                type="radio"
                name="no"
                value="no"
                v-model="lowerUsage"
                @change="setNextDisabled(false)"
              />
            </PathwaysOption>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import PathwaysOption from '@/components/pathways/PathwaysOption.vue';

const { mapActions } = createNamespacedHelpers('pathways');

export default {
  name: 'PathwaysQuestionLowerUsage',
  components: { PathwaysOption },
  computed: {
    lowerUsage: {
      get() {
        return this.$store.state.pathways.responses.lowerUsage;
      },
      set(value) {
        this.$store.dispatch('pathways/updateResponses', { lowerUsage: value });
      },
    },
  },
  mounted() {
    this.setNextDisabled(!this.lowerUsage);
  },
  methods: {
    ...mapActions({
      setNextDisabled: 'disableNext',
    }),
  },
};
</script>
